/* eslint-disable security/detect-non-literal-regexp */
/* eslint-disable security/detect-object-injection */
/* eslint-disable security/detect-unsafe-regex */
/* eslint-disable max-len */
import React, { useState, useEffect, useRef } from 'react'
import AuctionHeader from '../../auctionHeader'
import ClassicPreview from './classicPreview'
import SetupSection from '../commonLayout/setUpSection'
import SingleLotPreview from './singleLotPreview'
import MenuLinkModal from '../commonLayout/setUpSection/menuLinkModal'
import StandALonePreview from './standALonePreview'
import { generateInitialTermsAndCondition, initialFAQs, timeZoneMap } from '../../../../../CommonComponent/staticValues'
import { dataService } from '../../../../../services/dataService'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { Storage } from 'aws-amplify'
import uuid from 'react-uuid';
import { useOnClickOutside } from '../../../../../CommonComponent/outsideClick'
import { convertToWebP } from '../../../../../CommonComponent/convertToWebp'
import { Triangle } from 'react-loader-spinner'
import { useSelector } from 'react-redux'

export default function LiveAuctionCreator({ edit }) {

    const validTemplates = ['classic', 'single-lot', 'standalone'];

    function formatTemplateName(template) {
        const map = {
            'classic': 'Classic',
            'single-lot': 'Single Lot',
            'standalone': 'Standalone',
        };
        return map[template] || template;
    }

    const {id, template} = useParams();
    const state = useLocation();
    const price = useSelector((state)=>state.pricingSlice)
    const [editedAuctionData, setEditedAuctionData]=useState({});
    const outsideClickRef = useRef();
    const [isBanner, setIsBanner] = useState(true);
    const [loading, setLoading] = useState(false);
    const initialState = {
        auction_type: 'live',
        template_name: formatTemplateName(template),
        menu_links: [],
        logo_image: "",
        logo_redirection_url: "",
        title: "",
        auction_image: "",
        description: "",
        currency: "USD",
        start_date: null,
        accept_absentee_bid: true,
        accept_telephone_bid: true,
        registration_type: "Email only",
        add_buyer_fees: "Add percentage",
        percentage: price.plan_type=="Pro" ? '9' : '6',
        fees: '',
        faq:initialFAQs,
        time_zone: "",
        location: {
            address: '',
            latitude: '',
            longitude: ''
        },
        terms_and_condition: generateInitialTermsAndCondition(),
        publish_auction_results: false,
        toggle_powered_by_indy: false,
        make_your_auction_private: false,
        hide_auction_lots:false,
        passcode: "",
        font: {
            hearder_font: "",
            body_font: ""
        },
        buttons: {
            background_color: "",
            text_color: ""
        },
        header: {
            background_color: "",
            text_color: ""
        },
        content_area: {
            background_color: "",
            text_color: ""
        },
        footer: {
            background_color: "",
            text_color: ""
        },
        paddle: {
            background_color: "",
            text_color: ""
        }
    }

    let [auctionData, setAuctionData] = useState(initialState);
    const [saveDraftModal,setSaveDraftModal] = useState(false)
    const [errorMessages, setErrorMessages] = useState({
        logoError: '',
        logoRedirectionUrlError: '',
        auction_image_error: ''
    })
    const [newMenuLink, setNewMenuLink] = useState({
        title: '',
        link_url: '',
        dropdown: [{ title: '', link_url: ''}]
    });
    const [menuLinkError, setMenuLinkError] = useState({
        title: false,
        url: false,
    });
    const [isAddingDropdown, setIsAddingDropdown] = useState(false);
    const [menuModal, setMenuModal] = useState(false)
    const [dropdownLinkError, setDropdownLinkError] = useState([]);
    const [startDate, setStartDate] = useState('')
    const [startHour,setStartHour] = useState('')
    const [startMin,setStartMin] = useState('')
    const [loader, setLoader] = useState(false)
    const Navigate = useNavigate();
    const [logoLoader,setLogoLoader] = useState(false)
    const [imageLoader,setImageLoader] = useState(false)
    const [oldS3Images, setOldS3Images] = useState([]);
    
    // Local image storage for preview
    const [localImages, setLocalImages] = useState({
        logo_image: null,
        auction_image: null
    });
    
    const [text, setText]=useState("");
    const [mobileModal, isMobileModal] = useState(false);
    const [editMenu, setEditMenu] = useState({state: false, index: ''})

    useEffect(() => {
        if (!validTemplates.includes(template)) {
            Navigate('/page-not-found', { replace: true });
        }
    },[])

    // Cleanup local image URLs on component unmount to prevent memory leaks
    useEffect(() => {
        return () => {
            Object.values(localImages).forEach(imageData => {
                if (imageData?.localUrl) {
                    URL.revokeObjectURL(imageData.localUrl);
                }
            });
        };
    }, []);

    const handleDropdownClose=()=>{
        setMenuModal(false);
        document.body.classList.remove('modal-open');
        isMobileModal(false);
        setMenuLinkError({
            title: false,
            url: false,
        });
        setNewMenuLink({
            title: '',
            link_url: '',
            dropdown: [{ title: '', link_url: ''}]
        })
        setIsAddingDropdown(false);
    }

    useOnClickOutside(outsideClickRef, () => {
        handleDropdownClose()
    });

    const handleView = async()=>{
        const response = await dataService.viewAuction(`?auction_id=${id}`)
        if(response.error===false){
            const data = response.data.data;
            setAuctionData(
                {
                    ...data,
                    template_name: localStorage.getItem('selectedTemplateId')==1?'Classic':(localStorage.getItem('selectedTemplateId')==2?'Single Lot': 'Standalone'),
                }
            )
            const startTimestamp = data.start_date;

            // Function to convert timestamp to date in a particular timezone
            const getDateInTimezone = (timestamp, timezone) => {
                return new Date(timestamp).toLocaleString('en-US', { timeZone:  timezone || 'Etc/GMT'});
            };

            // Get date, hour, and minute of start date in the specified timezone
            const startDate = startTimestamp ? new Date(getDateInTimezone(startTimestamp, data.time_zone)) : null;
            const startHour = startDate ? String(startDate.getHours()).padStart(2, '0') : '';
            const startMin = startDate ? String(startDate.getMinutes()).padStart(2, '0') : '';

            setStartDate(data.start_date ? startDate : "");
            setStartHour(startHour);
            setStartMin(startMin);
            setText(data?.description);
            setLoading(false);
        }
    }
    
    useEffect(()=>{
        if(edit){
            setLoading(true);
            handleView();
        }
    },[])
  
    /**
     * The function `handleLogoChange` is used to handle the change event when a logo file is selected,
     * and it updates the state with the selected logo image and displays an error message if the file
     * size exceeds 5MB.
     */
    const handleLogoChange = async(event,image_type) => {
        if(image_type==='logo'){
            setLogoLoader(true)
        }
        else{
            setImageLoader(true)
        }
        const selectedLogo = event.target.files[0];
        const validLogoTypes = ['image/jpeg', 'image/png', "image/jpg"];
        const validImageTypes = ['image/jpeg', 'image/png', "image/jpg", 'image/gif'];
        if(image_type==='logo'){
            setErrorMessages((prevErrors) => ({
                ...prevErrors,
                logoError: ""
            }));
        }else{
            setErrorMessages((prevErrors) => ({
                ...prevErrors,
                auction_image_error: ""
            }));
        }
        if (image_type === 'logo') {
            if (!validLogoTypes.includes(selectedLogo?.type)) {
                setErrorMessages(prevErrors => ({
                    ...prevErrors,
                    logoError: "Please select a logo file in JPG or PNG format."
                }));
                setLogoLoader(false);
                return;
            }
        } else {
            if (!validImageTypes.includes(selectedLogo?.type)) {
                setErrorMessages(prevErrors => ({
                    ...prevErrors,
                    auction_image_error: "Please select a lead image in JPG, PNG or GIF format."
                }));
                setImageLoader(false);
                return;
            }
        }

        if (selectedLogo && selectedLogo.size <= 5 * 1024 * 1024) {
            // Track old S3 image for deletion if replacing an existing image
            if(image_type==='logo'){
                if (auctionData.logo_image && !auctionData.logo_image.startsWith('blob:')) {
                    setOldS3Images(prev => [...prev, auctionData.logo_image]);
                }
            } else {
                if (auctionData.auction_image && !auctionData.auction_image.startsWith('blob:')) {
                    setOldS3Images(prev => [...prev, auctionData.auction_image]);
                }
            }

            // Create local URL for preview
            const localImageUrl = URL.createObjectURL(selectedLogo);
            
            // Store the file and local URL for later S3 upload
            const imageData = {
                file: selectedLogo,
                localUrl: localImageUrl,
                name: selectedLogo.name,
                type: selectedLogo.type
            };

            if(image_type==='logo'){
                setLocalImages(prev => ({
                    ...prev,
                    logo_image: imageData
                }));
                setAuctionData(prevData => ({
                    ...prevData,
                    logo_image: localImageUrl // Use local URL for preview
                }));
                setEditedAuctionData((prevData) => ({
                    ...prevData,
                    logo_image: localImageUrl
                }));
                setTimeout(() => {
                    setLogoLoader(false)
                    setImageLoader(false);
                }, 500);
            }
            else{
                setLocalImages(prev => ({
                    ...prev,
                    auction_image: imageData
                }));
                setAuctionData(prevData => ({
                    ...prevData,
                    auction_image: localImageUrl
                }));
                setEditedAuctionData((prevData) => ({
                    ...prevData,
                    auction_image: localImageUrl
                }));
                setTimeout(() => {
                    setLogoLoader(false)
                    setImageLoader(false);
                }, 500);
            }
        } else {
            if(image_type==='logo'){
                setErrorMessages((prevErrors) => ({
                    ...prevErrors,
                    logoError: "Please select a logo file smaller than 5MB."
                }));
                setLogoLoader(false)
            }else{
                setErrorMessages((prevErrors) => ({
                    ...prevErrors,
                    auction_image_error: "Please select a lead image smaller than 5MB."
                }));
                setImageLoader(false)
            }
        }
    };
    /**
     * The function `handleLogoDelete` is used to delete local images and clear the preview.
     * S3 deletion is removed for security - images will only be uploaded when auction is saved.
     */
    const handleLogoDelete = (image_type) => {
        try {
            const isLogo = image_type === "logo";
            const localImageKey = isLogo ? "logo_image" : "auction_image";

            // Track old S3 image for deletion
            if (isLogo) {
                if (auctionData.logo_image && !auctionData.logo_image.startsWith('blob:')) {
                    setOldS3Images(prev => [...prev, auctionData.logo_image]);
                }
            } else {
                if (auctionData.auction_image && !auctionData.auction_image.startsWith('blob:')) {
                    setOldS3Images(prev => [...prev, auctionData.auction_image]);
                }
            }

            // Clean up local image URL to prevent memory leaks
            if (localImages[localImageKey]?.localUrl) {
                URL.revokeObjectURL(localImages[localImageKey].localUrl);
            }

            // Clear local image data
            setLocalImages(prev => ({
                ...prev,
                [localImageKey]: null
            }));

            setAuctionData((prev) => ({
                ...prev,
                ...(isLogo ? { logo_image: "", logo_redirection_url: "" } : { auction_image: "" }),
            }));

            setEditedAuctionData((prev) => ({
                ...prev,
                ...(isLogo ? { logo_image: "", logo_redirection_url: "" } : { auction_image: "" }),
            }));

            setErrorMessages((prev) => ({
                ...prev,
                ...(isLogo ? { logoError: "" } : { auction_image_error: "" }),
            }));

            if (isLogo) {
                setLogoLoader(false);
            } else {
                setImageLoader(false);
            }
        } catch (error) {
            console.error(`Error deleting ${image_type} image:`, error);
        }
    };
    /**
     * The function `handleLogoRedirectionChange` validates a URL entered by the user and updates the
     * state accordingly.
     */
    const handleLogoRedirectionChange = (event) => {
        event.preventDefault();
        const newRedirectionUrl = event.target.value;
        //const regex = '((http|https)://|(www.))?[a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)';
        const regex= '^(https?://|www\.)[a-zA-Z0-9@:%._\\+-~#?&//=]{2,256}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)'
        const urlPattern = new RegExp(regex);
        if (urlPattern.test(newRedirectionUrl) || newRedirectionUrl==='') {
            setAuctionData(prevData => ({
                ...prevData,
                logo_redirection_url: newRedirectionUrl
            }));
            setEditedAuctionData((prevData) => ({
                ...prevData,
                logo_redirection_url: newRedirectionUrl
            }));
            setErrorMessages((prevErrors) => ({
                ...prevErrors,
                logoRedirectionUrlError: ""
            }));
        } else {
            setErrorMessages((prevErrors) => ({
                ...prevErrors,
                logoRedirectionUrlError: "Enter a valid URL"
            }));
            setAuctionData(prevData => ({
                ...prevData,
                logo_redirection_url: newRedirectionUrl
            }));
            setEditedAuctionData((prevData) => ({
                ...prevData,
                logo_redirection_url: newRedirectionUrl
            }));
        }
    };
    /**
     * The function `addMenuLink` adds a new menu link to the `auctionData` state if the number of menu
     * links is less than 7.
     */


    const addMenuLink = () => {
        if (auctionData.menu_links.length < 7) {
            if(editMenu.state){
                setAuctionData((prevState) => ({
                    ...prevState,
                    menu_links: prevState.menu_links.map((link, index) =>
                        index === editMenu.index ? { ...link, ...newMenuLink } : link
                    ),
                }));
            }else{
                setAuctionData((prevState) => ({
                    ...prevState,
                    menu_links: [...prevState.menu_links, newMenuLink],
                }));
            }
            setNewMenuLink({
                title: '',
                link_url: '',
                dropdown: [{
                    title: '',
                    link_url: '',
                }],
            });
            setIsAddingDropdown(false)
            setMenuModal(false)
            document.body.classList.remove('modal-open')
        }
    };
    /**
     * The deleteMenuLink function is used to remove a menu link from the auction data by filtering out
     * the link at the specified index.
     */
    const deleteMenuLink = (index) => {
        setAuctionData((prevState) => ({
            ...prevState,
            menu_links: prevState.menu_links.filter((_, i) => i !== index),
        }));
    };
    /**
     * The function `addDropdownLink` adds a new dropdown link to the `newMenuLink` state if the number
     * of existing dropdown links is less than 5.
     */
    const addDropdownLink = () => {
        if (newMenuLink.dropdown.length < 5) {
            setNewMenuLink((prevState) => ({
                ...prevState,
                dropdown: [
                    ...prevState.dropdown,
                    {
                        title: '',
                        link_url: '',
                    },
                ],
            }));
        }
    };
    
    /**
     * Helper function to upload local images to S3
     */
    const uploadImagesToS3 = async (imageData) => {
        if (!imageData?.file) return null;
        
        try {
            const webpImage = await convertToWebP(imageData.file);
            const upload = await Storage.put(`DomainName/Auctions/images/${uuid()}/${webpImage.name.replaceAll(' ','')}`, webpImage, {
                contentType: webpImage.type,
            });
            return upload.key;
        } catch (error) {
            console.error('Error uploading image to S3:', error);
            return null;
        }
    };

    const deleteOldS3Images = async () => {
        try {
            if (!oldS3Images || oldS3Images.length === 0) return;

            const deletePromises = oldS3Images.map((imageKey) => {
                const body = { key: imageKey };
                return dataService.deleteImageFromS3(body);
            });

            await Promise.all(deletePromises);

        } catch (error) {
            console.error("Error deleting old S3 images:", error);
        }
    };



    /**
     * The function `handleCreateAuction` is an asynchronous function that handles the creation of an
     * auction by uploading images to S3 first, then making an API call to create the auction.
     */
    const handleCreateAuction = async(e)=>{
        e.preventDefault();
        setLoader(true)
        let data;

        try {
            // Upload all local images to S3 first
            const uploadPromises = [];
            const imageKeys = {};

            // Upload logo image
            if (localImages.logo_image) {
                uploadPromises.push(
                    uploadImagesToS3(localImages.logo_image).then(key => {
                        if (key) imageKeys.logo_image = key;
                    })
                );
            }

            // Upload auction image
            if (localImages.auction_image) {
                uploadPromises.push(
                    uploadImagesToS3(localImages.auction_image).then(key => {
                        if (key) imageKeys.auction_image = key;
                    })
                );
            }

            // Wait for all uploads to complete
            await Promise.all(uploadPromises);

            // Delete old S3 images after successful upload
            await deleteOldS3Images();

            // Prepare auction data with S3 keys
            let finalAuctionData = { ...auctionData };
            
            // Replace local URLs with S3 keys
            if (imageKeys.logo_image) {
                finalAuctionData.logo_image = imageKeys.logo_image;
            }
            if (imageKeys.auction_image) {
                finalAuctionData.auction_image = imageKeys.auction_image;
            }

            if(!edit){
                data = await dataService.CreateLiveAuction(finalAuctionData);
                if(data.error==false){
                    setAuctionData(initialState)
                    setSaveDraftModal(false)
                    setLoader(false)                                
                    if(data!==undefined && data.data.auctions_id!==undefined){
                        Navigate(`/auctions/${data.data._id}/${data.data.auctions_id}/overview`, 
                            {state: {message: 'Your auction has been created and saved as a draft'}})
                    }
                }else{
                    setSaveDraftModal(false)
                    setLoader(false)
                }
            }
            else{
                // Add any new image keys to edited data
                const updatedData = { ...editedAuctionData };
                Object.keys(imageKeys).forEach(key => {
                    if (imageKeys[key]) {
                        updatedData[key] = imageKeys[key];
                    }
                });
                
                // Always include menu_links and faq as they are managed separately
                updatedData.menu_links = auctionData.menu_links;
                updatedData.faq = auctionData.faq;
                                
                setTimeout(async() => {
                    data = await dataService.EditLiveAuction(auctionData.auction_id, updatedData)
                    if(data.error==false){
                        setAuctionData(initialState)
                        setSaveDraftModal(false)
                        setLoader(false)
                        if(auctionData.status=="Draft"){
                            Navigate(`/auctions/${id}/${auctionData.auction_id}/overview`, 
                                {state: {message: 'Your auction has been updated and saved as a draft'}})
                        }else{
                            Navigate(`/auctions/${id}/${auctionData.auction_id}/overview`, 
                                {state: {message: 'Your auction has been updated'}})
                        }
                    }else{
                        if(data.message?.status==400){
                            Navigate(`/auctions/${id}/${auctionData.auction_id}/overview`,  
                                {state : {error: data.message?.data?.message}})
                        }else{
                            Navigate(`/auctions/${id}/${auctionData.auction_id}/overview`, 
                                {state: {error: 'Something went wrong, please try again'}})
                        }
                    }
                }, 500);
            }
        } catch (error) {
            console.error('Error in handleCreateAuction:', error);
            setLoader(false);
            setSaveDraftModal(false);
        }
    }
    /**
     * The function `deleteDropdownLink` is used to remove a dropdown link from a menu and update the
     * state accordingly.
     */
    const deleteDropdownLink = (dropdownIndex) => {
        setNewMenuLink((prevState) => {
            const updatedLinks = prevState.dropdown.slice();
            if (Array.isArray(updatedLinks)) {
                if (dropdownIndex >= 0 && dropdownIndex < updatedLinks.length) {
                    updatedLinks.splice(dropdownIndex, 1);
                }
            }
            if(updatedLinks.length===0){
                setIsAddingDropdown(false)
                return {
                    ...prevState,
                    dropdown: [{ title: '', link_url: ''}]
                };
            }
            // setDropdownLinkError([])
            return {
                ...prevState,
                dropdown: updatedLinks, 
            };
        });
    };

    return (
        <div className="bg-[#F4F4F5]" >
            <AuctionHeader auctionData={auctionData} setAuctionData={setAuctionData}
                setEditedAuctionData={setEditedAuctionData}
                handleLogoChange={handleLogoChange}
                handleLogoRedirectionChange={handleLogoRedirectionChange} handleLogoDelete={handleLogoDelete}
                errorMessages={errorMessages}
                deleteMenuLink={deleteMenuLink}
                addDropdownLink={addDropdownLink}
                deleteDropdownLink={deleteDropdownLink}
                setNewMenuLink={setNewMenuLink}
                isAddingDropdown={isAddingDropdown} 
                setIsAddingDropdown={setIsAddingDropdown}
                setMenuModal={setMenuModal}
                startDate={startDate} 
                setStartDate={setStartDate}
                startHour={startHour}
                setStartHour={setStartHour}
                startMin={startMin}
                setStartMin={setStartMin}
                handleCreateAuction={handleCreateAuction}
                saveDraftModal={saveDraftModal}
                setSaveDraftModal={setSaveDraftModal}
                loader={loader}
                menuLinkError={menuLinkError} 
                logoLoader={logoLoader}
                setLogoLoader={setLogoLoader}
                imageLoader={imageLoader}
                setImageLoader={setImageLoader}
                mobileModal={mobileModal}
                isMobileModal={isMobileModal}
                setEditMenu={setEditMenu} edit={edit}
                isBanner={isBanner} setIsBanner={setIsBanner}
            />
            <div className={`w-full flex ${isBanner ? 'h-[calc(100vh-68px)]' : 'mt-[45px] max-h-[calc(100vh-113px)]' } `}>
                {template=='classic' ?
                    <ClassicPreview auctionData={auctionData}
                        startDate={startDate} 
                        setStartDate={setStartDate}
                        startHour={startHour}
                        setStartHour={setStartHour}
                        startMin={startMin}
                        setStartMin={setStartMin}
                    />
                    : (template=='single-lot'?
                        <SingleLotPreview auctionData={auctionData}
                            startDate={startDate} 
                            setStartDate={setStartDate}
                            startHour={startHour}
                            setStartHour={setStartHour}
                            startMin={startMin}
                            setStartMin={setStartMin}
                        />:
                        <StandALonePreview auctionData={auctionData}
                            startDate={startDate} 
                            setStartDate={setStartDate}
                            startHour={startHour}
                            setStartHour={setStartHour}
                            startMin={startMin}
                            setStartMin={setStartMin}
                        />)
                }
                <div id='web-panel-configuration' 
                    className={`xl:w-[26%] lg:w-[30%] md:w-[40%] md:block hidden border-l 
                        border-[#D4D4D8] bg-[#fff] 
                        ${isBanner ? 'h-[calc(100vh-68px)]' : 'max-h-[calc(100vh-113px)]' } 
                        overflow-y-scroll customScrollbar`}>
                  
                    <SetupSection auctionData={auctionData} setAuctionData={setAuctionData}
                        customId='auction_title'
                        customId1='auction_description'
                        date='auction_start_date'
                        setEditedAuctionData={setEditedAuctionData}
                        setText={setText}
                        text={text}
                        handleLogoChange={handleLogoChange}
                        handleLogoRedirectionChange={handleLogoRedirectionChange}
                        handleLogoDelete={handleLogoDelete}
                        errorMessages={errorMessages}
                        deleteMenuLink={deleteMenuLink}
                        setNewMenuLink={setNewMenuLink}
                        setMenuModal={setMenuModal}
                        startDate={startDate} 
                        setStartDate={setStartDate}
                        startHour={startHour}
                        setStartHour={setStartHour}
                        startMin={startMin}
                        setStartMin={setStartMin}
                        logoLoader={logoLoader}
                        setLogoLoader={setLogoLoader}
                        imageLoader={imageLoader}
                        setImageLoader={setImageLoader}
                        isMobileModal ={isMobileModal}
                        setEditMenu={setEditMenu}
                        edit={edit} />
                </div>
            </div>
            <MenuLinkModal 
                setMenuModal={setMenuModal} 
                menuModal={menuModal} 
                outsideClickRef={outsideClickRef}
                newMenuLink={newMenuLink} 
                setNewMenuLink={setNewMenuLink} 
                addMenuLink={addMenuLink} 
                isAddingDropdown={isAddingDropdown} 
                setIsAddingDropdown={setIsAddingDropdown} 
                addDropdownLink={addDropdownLink}
                deleteDropdownLink={deleteDropdownLink}
                dropdownLinkError={dropdownLinkError} 
                setDropdownLinkError={setDropdownLinkError}
                menuLinkError={menuLinkError} 
                setMenuLinkError={setMenuLinkError}
                auctionData={auctionData}
                mobileModal = {mobileModal}
                isMobileModal={isMobileModal}
                editMenu={editMenu}
                handleDropdownClose={handleDropdownClose}
            />
            {loading && (
                <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-[9999]">
                    <Triangle
                        height="80"
                        width="80"
                        color="#ffff"
                        ariaLabel="triangle-loading"
                        visible={true}
                    />
                </div>
            )}
        </div>
    )
}